import store from '@/store/index'
import { matchApplicableObjects } from './statusMap'

const { user: userState } = store.state
const { product: productState } = store.state

/**
 * 判断当前用户是否满足提交订单条件
 * @param {*} vm  vue 实例
 */
async function IsAllowUserSubmitApply(vm) {
  if (!userState.userInfo) {
    await store.dispatch('user/getUserInfo')
  }
  let result
  if (userState.userType === '法人') {
    result = await judgeLegal(vm)
  } else {
    result = await judgePerson(vm)
  }
  return result
}

async function judgeLegal(vm) {
  // 适用对象校验
  if (matchApplicableObjects(productState.productDetail.applicableObjects) === '个人') {
    vm.$notify.warning({ title: '抱歉', message: '申请该产品请使用个人账号登录' })
    return false
  }
  return true
}

async function judgePerson(vm) {
  // 适用对象校验
  if (matchApplicableObjects(productState.productDetail.applicableObjects) === '企业') {
    vm.$notify.warning({ title: '抱歉', message: '申请该产品请使用法人账号登录' })
    return false
  }
  // 认证等级校验
  if (Number(userState.userInfo.authlevel) !== 3) {
    vm.$router.push('/noAuth')
    return false
  }
  //   黑名单校验
  //   let isDishonesty = await store.dispatch('user/getUserDishonestyInfo', {
  //     cardId: userState.userInfo.idnum,
  //     name: userState.userInfo.username
  //   })
  //   if (isDishonesty === 'error') return false
  //   if (isDishonesty) {
  //     vm.$notify.warning({
  //       title: '抱歉',
  //       message: '您暂不符合该产品申请条件，可以在浙里掌上贷进行融资需求登记操作。'
  //     })
  //     vm.$router.push({ name: 'product-detail' })
  //     return false
  //   }
  return true
}
export { IsAllowUserSubmitApply }
